import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { LoginFormComponent } from './pages/login-form/login-form.component';
import { authGuard } from './auth.guard';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { PairingComponent } from './pages/pairing/pairing.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { TwoFactorComponent } from './pages/two-factor/two-factor.component';
import { SetUpTwoFactorComponent } from './pages/set-up-two-factor/set-up-two-factor.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'login',
    component: LoginFormComponent,
  },
  {
    path: 'pairing',
    component: PairingComponent,
  },
  {
    path: 'forgot',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset',
    component: ResetPasswordComponent,
  },
  {
    path: 'two-factor',
    component: TwoFactorComponent,
  },
  {
    path: 'set-up-two-factor',
    component: SetUpTwoFactorComponent,
    canActivate: [authGuard],
  },
  { path: '**', component: NotFoundComponent },
];
